<template>
  <svg
    width="11"
    height="18"
    viewBox="0 0 11 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.91313 1.24581C10.1409 1.01801 10.1409 0.648661 9.91313 0.420855C9.68532 0.19305 9.31598 0.19305 9.08817 0.420855L0.921503 8.58752C0.693696 8.81533 0.693696 9.18467 0.921503 9.41248L9.08817 17.5791C9.31598 17.807 9.68532 17.807 9.91313 17.5791C10.1409 17.3513 10.1409 16.982 9.91313 16.7542L2.15894 9L9.91313 1.24581Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ChevronIcon extends Vue {}
</script>
